export default "__VITE_ASSET__82985ae8__"